import { Http } from '../Utils/Http';
import { AxiosResponse } from 'axios';
import { IUserDataAxiosResponse } from './interfaces/User/IUserData';

export class TenantApiV2 {
  static async listUsers(): Promise<AxiosResponse<IUserDataAxiosResponse>> {
    const axios = await Http.axios();
    return axios.get('/v2/tenants/users');
  }
}
